import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiMainAuctionService } from 'src/app/features/bidders/core/service/api-main-auction.service';
import { SocketService } from 'src/app/features/bidders/core/service/socket.service';
import { BidderList } from 'src/app/features/multi-auction-bidder/core/modal/bidders-list';
import { ListModal } from 'src/app/features/multi-auction-bidder/core/modal/list-modal';
import { RoomDetailesModal } from 'src/app/features/multi-auction-bidder/core/modal/roomDetailes-modal';
import { interval, Subscription } from 'rxjs';
import { SocketEventType } from 'src/app/features/bidders/core/modal/socket-event-type';
import { NotEnoughFundComponent } from 'src/app/features/bidders/component/auction/not-enough-fund/not-enough-fund.component';
import { MatDialog } from '@angular/material/dialog';
import { RemainingTimeBetweenModal } from 'src/app/features/multi-auction-bidder/core/modal/remaining-time-between-modal';
import { SocketUpates } from 'src/app/features/rooms/core/modal/socketUpdates';
import { socketActions } from 'src/app/features/rooms/core/enums/socketActions';
import { UserCases } from './multi-live-bidding/enum/userCases';
import { HardRedirectComponent } from '../../hard-redirect/hard-redirect.component';
import { OfflineComponent } from '../../offline/offline.component';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-main-room',
  templateUrl: './main-room.component.html',
  styleUrls: ['./main-room.component.css']
})
export class MainRoomComponent implements OnInit {
  roomID!: string;
  loadingData = false;
  roomdetails!: RoomDetailesModal
  itemDetails!: ListModal;
  loadingItemsDetalis = true;
  lastUserBidding: BidderList | undefined;
  getLastbidding: boolean = false;
  subscriptions: Subscription[] = [];
  subscription!: Subscription;
  activeAuctionWork: any;
  listBidders: any;
  closedAuctionSocket: any;
  newBidding: any;
  auctionPause: any;
  auctionRemainingTime!: number;
  auctionRemainingTimeBetween!: RemainingTimeBetweenModal;
  auctionRemainingTimeNoBid: RemainingTimeBetweenModal | undefined;
  listginItem!: ListModal[];
  reloadList: number = 0;

  CurrentCase!: UserCases
  OnlineStatus: boolean = true;
  constructor(
    private dialog: MatDialog, private _SharedService: SharedService,
    private _activatedRouter: ActivatedRoute, private _roomService: ApiMainAuctionService, public _config: ConfigService, public socket: SocketService,) { }

  ngOnInit() {
    this.roomID = this._activatedRouter.snapshot.params["id"];
    if (this._config.getAuthUserInfo()) {
      this.socket.socket.emit(`join`, this.roomID);
    }
    //this.socket.socket.emit(`getActiveItem`,this.roomID);
    this.getRoomDetail();

    this.socket.roomNotVaild(this.roomID);
    this.socket.getActiveItem(this.roomID);
    this.socket.roomClosed(this.roomID);

    this.subscriptions.push(
      this.socket.getDataStream<string>(`roomNotVaild${this.roomID}`)
        .subscribe(message => {
          this._config._router.navigate(['/'])
          this._config.toastrService.clear();
          this._config.toastrService.error(this._config.translate.instant('multiAuction.roomNotVaild'), '');
        })
    )


    this.subscriptions.push(
      this.socket.getDataStream<string>(`roomClosed${this.roomID}`)
        .subscribe(message => {
          // debugger
          let data = message.data.response;
          this.closedAuctionSocket = this.activeAuctionWork;
          // let item = this.listginItem.find(obj => obj.id == this.activeAuctionWork);
          // item!.is_closed = 1;
          this.listginItem.forEach(element => {
            if (element.id == this.activeAuctionWork) {
              element.is_closed = 1;
            }
          });
          this.roomdetails.type = 'completed';
          this.auctionRemainingTime = 0;
          // this.activeAuctionWork = this.listginItem[0]?.id;
          // this.itemDetails = this.listginItem[0];

        })
    )

    this.subscriptions.push(
      this.socket.getDataStream<string>(`getActiveItem`)
        .subscribe(message => {
          let data = message.data.response;

          if (data.roomID == this.roomID) {
            this.closedAuctionSocket = this.activeAuctionWork;
            this.activeAuctionWork = data.auctionID;
            this.auctionRemainingTime = data.remaining;  //
            this.auctionRemainingTimeBetween = data.remainingBetween;
            this.auctionRemainingTimeNoBid = data.remainingNoBids;
            this.auctionPause = data.pause;
            this.roomdetails.is_pause = data.pause;
            // if (this.roomdetails) {
            this.roomdetails.type = 'ongoing';
            // }
            // console.log(data.pause);

            if (data.remaining == 0) {

              //  let indexItem = this.listginItem.findIndex( obj =>  obj.id == data.auctionID);
              //   this.activeAuctionWork = this.listginItem.length == (indexItem+1) ? this.activeAuctionWork :  this.listginItem[(indexItem+1)];

            }

            if (data.roomID == this.roomID && data.remaining == null && data.remainingBetween?.remainingStart == 0 && data.auctionID != this.listginItem[0]?.id) {
              this.closedAuctionSocket = this.activeAuctionWork;
              this.activeAuctionWork = data.auctionID;
              this.auctionRemainingTime = data.remaining;
              this.auctionRemainingTimeBetween = { remainingStart: this.roomdetails.time_between_items, type: this.roomdetails.interval_between_items };
            }
            this.HandelUserCase()
          }


        })
    )

    // To detect if any updated happend in this auction
    this.subscriptions.push(
      this.socket.getDataStream<string>(`room-or-auction-updated`)
        .subscribe(message => {
          let data: SocketUpates = message.data;
          this.OpenConfirmRedirect(data)
        })
    )

    this.notEnoughFund();
    this._SharedService.GetOnlineStatus().subscribe(status => {
      if (status && !this.OnlineStatus) {
        this.getRoomDetail();
      }
      this.OnlineStatus = status;
    })
  }

  notEnoughFund() {
    this.subscriptions.push(
      this.socket.getDataStream<string>(SocketEventType.Not_Enough_Fund)
        .subscribe(message => {

          const dialogRef = this.dialog.open(NotEnoughFundComponent, {
            width: '550px',
            panelClass: 'customDialogStyle'
          });
        })
    )

  }


  lastBid(event: any) {

    if (event)
      this.lastUserBidding = event;

    this.getLastbidding = true;

  }
  allListginItem(event: any) {
    this.listginItem = event;
  }

  getRoomDetail() {
    this.loadingData = true
    console.log(this.roomID);
    this._roomService.GetMainAuctionDetailes(this.roomID).subscribe({
      next: (data) => {

        this.roomdetails = data.data

        if (!this.roomdetails.is_multi_auction) {
          if (this._config.getAuthUserInfo()?.user?.role_code == "General") {
            this._config.goTo("/MainAuction/" + this.roomdetails?.id);
          } else {
            this._config.goTo("/rooms/detailes/" + this.roomdetails?.id);
          }
        }

        if ((!this.roomdetails.is_me_joined || !this.roomdetails.is_closed) || this.roomdetails.is_closed) {
          this.loadingData = false;
        }
        this.loadingData = false;
        this.HandelUserCase();
      }, error: (err) => {
        // this.loadingData = false
        this._config.showErrors(err)
      }
    }

    )
  }
  unsubscribeTimerAuctionNoEndTime() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getItemsActive(data: any) {
    console.log(data);
    // debugger
    // data.showActions = false;
    this.itemDetails = { ...data, showActions: this.roomdetails?.can_edit };
    this.loadingItemsDetalis = false;

    this.HandelUserCase()

  }

  getBidders(event: any) {
    // console.log(event);

    this.listBidders = event;
  }


  newBiddingListener(data: any) {
    this.newBidding = data;
  }

  HandelUserCase() {
    // debugger
    // console.log("Call HandelUserCase ");
    if (this.auctionPause &&
      this.itemDetails?.id == this.activeAuctionWork) {
      this.CurrentCase = UserCases.Pause;
      // console.log("======================> " +  UserCases.Pause);
    }
    else if (this.roomdetails?.is_me_joined &&
      !this.itemDetails?.is_closed &&
      this.itemDetails?.id != this.activeAuctionWork &&
      this.activeAuctionWork) {
      this.CurrentCase = UserCases.Not_Available;
      // console.log("======================> " +  UserCases.Not_Available);

    }
    else if (this.itemDetails?.id == this.activeAuctionWork &&
      this.auctionRemainingTimeBetween?.remainingStart > 0 &&
      !this.auctionPause) {
      this.CurrentCase = UserCases.Timer_Between;
      // console.log("======================> " +  UserCases.Timer_Between);

    }
    else {
      this.CurrentCase = UserCases.Biding;
      // console.log("======================> " +  UserCases.Pause);

    }
  }


  onUserJoinOrWithdraw(flag: boolean) {
    this.roomdetails.is_me_joined = flag;
    this.HandelUserCase();
  }

  OpenConfirmRedirect(actionType: SocketUpates) {
    let title, lable, action: string = ''

    // when room Deleted or unpublished
    if (actionType.isChangeOnRoom && actionType.roomId == this.roomID) {
      if (actionType.typeChanges == socketActions.DELETED || actionType.typeChanges == socketActions.UN_PUBLISHED) {
        title = "multiAuction.Hard Redirect"
        lable = "multiAuction.this auction has been Deleted."
        action = 'go_home';
      }
      else if (actionType.typeChanges == socketActions.UPDATED) {
        title = "multiAuction.Update your auction information"
        lable = "multiAuction.this auction has been updated form administrator press Confirm to continue"
        action = 'reload';
      }
    }

    if (action) {
      this.dialog.closeAll();
      const dialogRef = this.dialog.open(HardRedirectComponent, {
        width: '550px',
        data: { title, lable },
        panelClass: 'customDialogStyle',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe((res: any) => {
        if (res)
          switch (action) {
            case 'reload':
              this.getRoomDetail();
              break;
            case 'go_home':
              if (this._config.getAuthUserInfo().user?.role_code == "General") {
                this._config.goTo("/")
              } else {
                this._config.goTo("/rooms")
              }
              break;
          }

      })
    }

  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
